<template>
  <div class="default-layout">
      <router-link :to="{ name: 'Home' }" @click="closeAboutContentFullDetail">
        <ImgSVG v-if="this.$route.name !== 'Events'" :src="ucallLogo" class="img logo" alt="ucall logo"/>
      </router-link>
      <app-menu />
    <router-view />
<!--     <footer class="site-footer" aria-label="Rodapé">
      <div class="footer-inner">
        <router-link class="footer-link" :to="{ name: 'CookiePolicy' }">Leia aqui a política de cookies</router-link>
        <span class="footer-sep" aria-hidden="true">•</span>
        <router-link class="footer-link" :to="{ name: 'PrivacyPolicy' }">Leia aqui a política de privacidade</router-link>
      </div>
    </footer> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuThemeConfigs from '@/utils/menu-route-theme'
import MenuComponent from '@/components/Menu/MenuComponent'
import ImgSVG from '@/components/ImgSVG'
import TweenLite from 'gsap/TweenLite'
let flexData
export default {
  name: 'DefaultLayout',
  metaInfo: {
    htmlAttrs: {
      lang: 'pt'
    }
  },
  watch: {
    '$i18n.locale': {
      handler: async function (after, before) {
        await this.$store.dispatch('setAppConfig', { lang: this.$i18n.locale })
      },
      deep: true
    },
    $route: {
      handler: function () {
        const themeEntry = this.themesConfig.filter(item => item.route === this.$route.name)[0]
        let routeTheme = themeEntry ? themeEntry.theme : 'ThemeHome'
        this.$store.commit('menu/SET_MENU_THEME', routeTheme)
        // <<<<<<< HEAD
        //         this.ucallLogo = ['People', 'Cases'].includes(this.$route.name) ? require('@/assets/ucall_logo.svg') : require('@/assets/logo_branco.svg')
        //         this.hideLogo()
        // =======
        this.$store.dispatch('about/setRouteName', this.$route.name)
        this.ucallLogo = require('@/assets/logo.svg')
        const body = document.body
        if (['Cases', 'People', 'PrivacyPolicy', 'CookiePolicy', 'TermsConditions'].includes(this.$route.name)) {
          body.classList.remove('custom-brand')
          body.style.setProperty('--brand-color', '')
        } else {
          body.classList.add('custom-brand')
          body.style.setProperty('--brand-color', '#fff')
        }
        // this.ucallLogo = ['Cases', 'People'].includes(this.$route.name) ? require('@/assets/ucall_logo.svg') : require('@/assets/logo_branco.svg')
        // this.hideLogo()
        /* const menu = document.querySelector('.menu')
        const logo = document.querySelector('.logo')
        if (logo) {
          if (this.$route.name === 'Login' || this.$route.name === 'Recover') {
            logo.style.visibility = 'hidden'
          } else {
            logo.style.visibility = 'inherit'
          }
        }
        if (menu) {
          if (menu && this.$route.name === 'Case') {
            menu.style.display = 'none'
            return
          }
          menu.style.display = 'block'
        } */
      },
      immediate: true
    }
  },
  components: {
    'app-menu': MenuComponent,
    ImgSVG
  },
  data () {
    return {
      themesConfig: MenuThemeConfigs,
      ucallLogo: '',
      nameRoute: ''
    }
  },
  computed: {
    ...mapGetters('about', ['currentNameRoute', 'currentContentVisibility'])
  },
  created () {
    this.nameRoute = this.currentNameRoute
  },
  async mounted () {
    // this.hideLogo()
    await this.$store.dispatch('setAppConfig', { lang: this.$i18n.locale })
    await this.$store.dispatch('about/setRouteName', this.$route.name)
    this.nameRoute = this.currentNameRoute
  },
  methods: {
    alterNameRoute () {
    },
    hideLogo () {
      const el = document.querySelector('#menu')
      const logo = document.querySelector('.logo')
      if ((logo && this.$route.name === 'Login') || (logo && this.$route.name === 'Recover')) {
        document.querySelector('.logo').style.visibility = 'hidden'
        return
      }
      if (el) {
        if (el && this.$route.name === 'Case') {
          document.querySelector('#menu').style.display = 'none'
          return
        }
        document.querySelector('#menu').style.display = 'block'
      }
    },
    async closeAboutContentFullDetail () {
      await this.$store.dispatch('about/setRouteName', 'About')
      await this.$store.dispatch('about/setContentVisibility', 'middle')
      TweenLite.to('.about-detail', 0.4)
      TweenLite.to('.list-about', 0.4, { flex: flexData })
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  width: 100%;
  z-index: 999;
  display: inline-flex;
  padding-top: 2vh;
}
.router-link-active {
  z-index: 9;
  position: fixed
}

.default-layout {
  height: 100vh;
  margin: 0 !important;
  padding: 0 !important;
}

img.logo, .img.logo {
  margin: 0;
  display: none;
  transition: all .26s linear;
}

@media (min-width: 960px) {
  img.logo, .img.logo {
    display: block !important;
    height: auto;
    width: 230px;
    position: relative;
    margin-top: 1.2em;
    margin-left: 4em;
  }
}

.site-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  padding: 10px 16px;
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(4px);
}
.footer-inner { display: flex; gap: 10px; align-items: center; }
.footer-link { color: #fff; text-decoration: underline; font-size: 12px; }
.footer-sep { color: #fff; opacity: 0.7; }
</style>
